export const APP_CONSTANTS = {
    REACT_E_COMMERCE_TOKEN: 'react_e_commerce_token'
  };
  